// src/components/DirectPromotionsFilters.js
import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';

import DropDown from './DropDown';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

export default class DirectPromotionsFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      addNew: false,
      filtersCounter: 0,
      allowEdit: !!props.allowEdit,

      // inputs
      nameLike: '',
      clientId: '',
      customFrom: '',
      customTo: '',
      datePreset: 'ANY',
      status: 'ANY',

      statusOptions: {
        ANY: 'Any',
        0: 'Registered',
        1: 'Claimed',
        2: 'Consumed',
        3: 'Missed',
        4: 'Pending'
      },

      datePresetOptions: {
        ANY:        'Any time',
        CUSTOM:     'Custom range',
        TODAY:      'Today',
        LAST_7:     'Last 7 days',
        NEXT_7:     'Next 7 days',
        LAST_30:    'Last 30 days',
        NEXT_30:    'Next 30 days',
        THIS_MONTH: 'This month',
        PREV_MONTH: 'Previous month',
      },
    };

    this.queryData = {};
    this.toggleAdd = this.toggleAdd.bind(this);
    this.apply = this.apply.bind(this);
    this.reset = this.reset.bind(this);
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  componentDidMount() {
    const today = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const ymd = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    this.setState({ customFrom: ymd, customTo: ymd });
    this.apply();
  }

  ddmmyyyy(date) {
    const d = new Date(date);
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  }

  ymdToDmy = (s) => {
    if (!s || s.length < 10) return '';
    const [y, m, d] = s.split('-');
    return `${d}-${m}-${y}`;
  };
  endOfDayDmy = (s) => {
    const dmy = this.ymdToDmy(s);
    return dmy ? `${dmy} 23:59:59` : '';
  };

  computeDateRange(preset) {
    const today = new Date();
    const startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    const inDays = (n) => new Date(startOfToday.getTime() + n * 86400000);
    const set = (from, to) => ({
      dateFrom_gte: from ? this.ddmmyyyy(from) : undefined,
      dateTo_lte:   to   ? this.ddmmyyyy(to)   : undefined,
    });
    switch (preset) {
      case 'TODAY':      return set(startOfToday, startOfToday);
      case 'LAST_7':     return set(inDays(-6), startOfToday);
      case 'NEXT_7':     return set(startOfToday, inDays(6));
      case 'LAST_30':    return set(inDays(-29), startOfToday);
      case 'NEXT_30':    return set(startOfToday, inDays(29));
      case 'THIS_MONTH': return set(new Date(today.getFullYear(), today.getMonth(), 1),
                                    new Date(today.getFullYear(), today.getMonth()+1, 0));
      case 'PREV_MONTH': return set(new Date(today.getFullYear(), today.getMonth()-1, 1),
                                    new Date(today.getFullYear(), today.getMonth(),   0));
      default:           return set(undefined, undefined);
    }
  }

  apply() {
    // Always include sane defaults
    const q = { ...this.queryData, limit: 20, order: '-dateFrom' };
    this.setState({ filtersCounter: Object.keys(this.queryData).length });
    this.props.applyFilters(q);
  }

  handleExpandClick() { this.setState((s) => ({ expanded: !s.expanded })); }
  toggleAdd() { if (this.state.allowEdit) { this.setState((s)=>({addNew:!s.addNew})); this.props.toggleAdd(); } }

  reset() {
    this.queryData = {};
    const today = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    const ymd = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    this.setState({
      nameLike: '',
      clientId: '',
      customFrom: ymd,
      customTo: ymd,
      datePreset: 'ANY',
      status: 'ANY',
      filtersCounter: 0,
    });
    this.props.applyFilters(this.queryData);
  }

  render() {
    return (
      <Card sx={{ borderRadius: '16px', m: 1, backgroundColor: '#214a80' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <IconButton aria-label="Add" title="Add" onClick={this.toggleAdd}>
              <Avatar alt="Add" sx={{ width: 24, height: 24, color: '#273442' }}>
                {this.state.addNew ? <FaMinusCircle /> : <FaPlusCircle />}
              </Avatar>
            </IconButton>

          <TextField
            label="Name contains"
            variant="standard"
            value={this.state.nameLike}
            onChange={(e) => {
              const v = e.target.value;
              this.setState({ nameLike: v });
              if (v && v.length > 2) this.queryData.nameLike = v; else delete this.queryData.nameLike;
              this.apply();
            }}
            InputLabelProps={{ sx: { color: '#e3e3e5' } }}
            inputProps={{ sx: { color: '#e3e3e5' } }}
            sx={{ color: "#e3e3e5", ml: 2 }}
          />

          <DropDown
            name="Status"
            value={String(this.state.status)}
            doptions={this.state.statusOptions}
            onChangeFunction={(v) => {
              this.setState({ status: v });
              if (v === 'ANY') delete this.queryData.status; else this.queryData.status = v;
              this.apply();
            }}
            minWidth={120}
            size="small"
            marginTop={8}
          />

          <TextField
            label="Client ID"
            variant="standard"
            value={this.state.clientId}
            onChange={(e) => {
              const v = e.target.value.trim();
              this.setState({ clientId: v });
              if (v) this.queryData.client = v; else delete this.queryData.client;
              this.apply();
            }}
            InputLabelProps={{ sx: { color: '#e3e3e5' } }}
            inputProps={{ sx: { color: '#e3e3e5' } }}
            sx={{ color: "#e3e3e5", ml: 2, width: 140 }}
          />

          <DropDown
            name="Date range"
            value={String(this.state.datePreset)}
            doptions={this.state.datePresetOptions}
            onChangeFunction={(v) => {
              this.setState({ datePreset: v });
              delete this.queryData.dateFrom_gte; delete this.queryData.dateTo_lte;
              if (v !== 'ANY' && v !== 'CUSTOM') {
                const { dateFrom_gte, dateTo_lte } = this.computeDateRange(v);
                if (dateFrom_gte) this.queryData.dateFrom_gte = dateFrom_gte;
                if (dateTo_lte)   this.queryData.dateTo_lte   = `${dateTo_lte} 23:59:59`;
              }
              this.apply();
            }}
            minWidth={140}
            size="small"
            marginTop={8}
          />

          {this.state.datePreset === 'CUSTOM' && (
            <>
              <TextField
                type="date"
                label="From"
                variant="standard"
                value={this.state.customFrom}
                onChange={(e) => {
                  const ymd = e.target.value;
                  this.setState({ customFrom: ymd });
                  const dmy = this.ymdToDmy(ymd);
                  if (dmy) this.queryData.dateFrom_gte = dmy; else delete this.queryData.dateFrom_gte;
                  this.apply();
                }}
                InputLabelProps={{ shrink: true, sx: { color: '#e3e3e5' } }}
                InputProps={{ sx: { color: '#e3e3e5' } }}
                sx={{ ml: 2 }}
              />
              <TextField
                type="date"
                label="To"
                variant="standard"
                value={this.state.customTo}
                onChange={(e) => {
                  const ymd = e.target.value;
                  this.setState({ customTo: ymd });
                  const dmyEnd = this.endOfDayDmy(ymd);
                  if (dmyEnd) this.queryData.dateTo_lte = dmyEnd; else delete this.queryData.dateTo_lte;
                  this.apply();
                }}
                InputLabelProps={{ shrink: true, sx: { color: '#e3e3e5' } }}
                InputProps={{ sx: { color: '#e3e3e5' } }}
                sx={{ ml: 2 }}
              />
            </>
          )}

          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
            <Typography variant="body2" sx={{ color: '#e3e3e5' }}>Items: {this.props.itemsCounter}</Typography>
            <Typography variant="body2" sx={{ color: '#e3e3e5' }}>Filters: {this.state.filtersCounter}</Typography>
            {this.state.filtersCounter > 0 && (
              <IconButton aria-label="Remove Filters" title="Remove Filters" onClick={this.reset}>
                <Avatar sx={{ width: 18, height: 18, color: '#99302e' }}><HighlightOffIcon fontSize="small" /></Avatar>
              </IconButton>
            )}
            <ExpandMore expand={this.state.expanded} onClick={this.handleExpandClick} aria-expanded={this.state.expanded} aria-label="show more">
              <ExpandMoreIcon />
            </ExpandMore>
          </Box>
        </Box>

        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
          {/* Keep this area for future extra filters if needed */}
        </Collapse>
      </Card>
    );
  }
}
